import { createFileRoute } from '@tanstack/react-router';

import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { ReceivingPurchaseOrderPage } from '../../modules/receiving/receiving-purchase-order-page.js';

export const Route = createFileRoute('/receiving/$purchaseOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: ReceivingPurchaseOrderRoute,
});

// eslint-disable-next-line react-refresh/only-export-components
function ReceivingPurchaseOrderRoute() {
  const { purchaseOrderId } = Route.useParams();
  return <ReceivingPurchaseOrderPage purchaseOrderId={purchaseOrderId} />;
}
